












































































import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api"
import { useGetters } from "vuex-composition-helpers"
import { ObserverExchangeBus } from "@/shared/composables/ObserverExchangeBus"
import { IAdmission, IAdmissions } from "@/apps/StudentExchangeOverviewWidget/models/admissions-viewmodel"
import { IExchange } from "@/apps/StudentExchangeOverviewWidget/models/exchanges-viewmodel"
import Exchanges from "@/apps/StudentExchangeOverviewWidget/components/Exchanges.vue"
import Observer from "@/apps/StudentExchangeOverviewWidget/components/molecules/Observer.vue"

export default defineComponent({
    name: "StudentExchangeOverviewWidget",
    components: {
        Observer,
        Exchanges
    },
    props: {
        academicYear: {
            type: String,
            required: false,
            default: ''
        },
        academicYearId: {
            type: String,
            required: false,
            default: ''
        },
        admissions: {
            type: Array as PropType<IAdmissions>,
            required: false,
            default: () => []
        },
        isLast: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup: (props) => {
        const {
            getLabels,
            getSelectedFilterStudy
        } = useGetters([
            'getLabels',
            'getSelectedFilterStudy'
        ])
        const intersect = ref(true)
        const isElementInViewport = ref(false)

        const studyAdmissions = computed(() => {
            return props.admissions.filter((admission: IAdmission) => {
                if (getSelectedFilterStudy.value) {
                    return admission.programOfStudyId === getSelectedFilterStudy.value
                } else {
                    return true
                }
            })
        })
        
        const groups = computed(() => {
            let groupIndexArray = props.admissions?.map((admission: IAdmission) => {
                return admission.exchanges?.map((exchange: IExchange) => {
                    return exchange.groupIndex
                })
            })
            return new Set(groupIndexArray.flat().sort())
        })

        const customClickEvent = new CustomEvent("informationModalEvent", {
            detail: {
                offset: 0
            }
        })
        
        function onInformationClick() {
            customClickEvent.detail.offset = document.documentElement.scrollTop || document.body.scrollTop;

            window.document.dispatchEvent(customClickEvent)
        }
        
        function intersected() {
            isElementInViewport.value = !isElementInViewport.value
            intersect.value = !intersect.value
        }

        watch(
            () => ObserverExchangeBus().intersected,
            (newState, oldState) => {
                if(newState) {
                    intersected()
                    ObserverExchangeBus().intersected = false
                }
            }
        )
        
        return {
            groups,
            getLabels,
            intersect,
            intersected,
            studyAdmissions,
            onInformationClick,
            isElementInViewport
        }
    }
})
